/* Default icons are required for TinyMCE 5.3 or above */
import 'tinymce/icons/default';

/* A theme is also required */
import 'tinymce/themes/silver';

/* Import the skin */
import 'tinymce/skins/ui/oxide/skin.css';

/* Import plugins */

/* Basic plugins */
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/image';
import 'tinymce/plugins/quickbars';

/* Advanced and large plugins (740 KB) */
// import 'tinymce/plugins/advlist';
// import 'tinymce/plugins/code';
// import 'tinymce/plugins/emoticons';
// import 'tinymce/plugins/emoticons/js/emojis';
// import 'tinymce/plugins/print';
// import 'tinymce/plugins/preview';
// import 'tinymce/plugins/importcss';
// import 'tinymce/plugins/searchreplace';
// import 'tinymce/plugins/autolink';
// import 'tinymce/plugins/autosave';
// import 'tinymce/plugins/save';
// import 'tinymce/plugins/directionality';
// import 'tinymce/plugins/visualblocks';
// import 'tinymce/plugins/visualchars';
// import 'tinymce/plugins/fullscreen';
// import 'tinymce/plugins/imagetools';
// import 'tinymce/plugins/media';
// import 'tinymce/plugins/template';
// import 'tinymce/plugins/codesample';
// import 'tinymce/plugins/charmap';
// import 'tinymce/plugins/hr';
// import 'tinymce/plugins/pagebreak';
// import 'tinymce/plugins/nonbreaking';
// import 'tinymce/plugins/anchor';
// import 'tinymce/plugins/toc';
// import 'tinymce/plugins/insertdatetime';
// import 'tinymce/plugins/wordcount';
// import 'tinymce/plugins/textpattern';
// import 'tinymce/plugins/noneditable';
// import 'tinymce/plugins/help';
